import React from 'react';
const Divider = ({
  classNames
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  });
};
export default Divider;